/* ==================================================================
   Rêve Èclatant — the house countdown.
   Shopify asset: assets/reve-countdown.js

   The date comes from the page, from Theme settings → Countdown. Leave that
   empty and the countdown holds its frozen 14 day reading; set it and the
   numbers run for real.

   When the numbers reach zero the page reloads itself once, so the server
   renders the open state: the front page becomes the collection and the
   menus come back. Nothing here has to unlock anything on its own.
   ================================================================== */

(function () {
  "use strict";

  var root = document.querySelector("[data-reve-countdown]");
  if (!root) return;

  var FROZEN = { days: 14, hours: 0, minutes: 0, seconds: 0 };
  var OPENS_AT = root.getAttribute("data-opens-at") || "";

  var nodes = {
    days: root.querySelector('[data-unit="days"]'),
    hours: root.querySelector('[data-unit="hours"]'),
    minutes: root.querySelector('[data-unit="minutes"]'),
    seconds: root.querySelector('[data-unit="seconds"]'),
  };

  function pad(value) {
    return String(value).padStart(2, "0");
  }

  function paint(parts) {
    if (nodes.days) nodes.days.textContent = pad(parts.days);
    if (nodes.hours) nodes.hours.textContent = pad(parts.hours);
    if (nodes.minutes) nodes.minutes.textContent = pad(parts.minutes);
    if (nodes.seconds) nodes.seconds.textContent = pad(parts.seconds);
  }

  // The server's own epoch for the opening moment, in seconds. Using it keeps
  // the browser and the server agreeing on the same instant in every browser
  // and timezone; parsing the date text would not.
  var ts = Number(root.getAttribute("data-opens-ts"));
  var target = OPENS_AT && ts > 0 ? ts * 1000 : NaN;

  if (!target || Number.isNaN(target)) {
    paint(FROZEN);
    return;
  }

  var timer = null;
  var reloaded = false;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function remaining() {
    var left = Math.max(0, target - Date.now());
    var totalSeconds = Math.floor(left / 1000);
    return {
      days: Math.floor(totalSeconds / 86400),
      hours: Math.floor((totalSeconds % 86400) / 3600),
      minutes: Math.floor((totalSeconds % 3600) / 60),
      seconds: totalSeconds % 60,
      done: left === 0,
    };
  }

  function tick() {
    var parts = remaining();
    paint(parts);

    if (!parts.done) return;

    if (timer) {
      window.clearInterval(timer);
      timer = null;
    }

    // the doors have opened: ask the server for the open page, once
    if (reloaded) return;
    reloaded = true;
    try {
      var key = "reve:opened:" + ts;
      if (window.sessionStorage.getItem(key) === "1") return;
      window.sessionStorage.setItem(key, "1");
    } catch (error) {
      // storage blocked: reload anyway, once
    }
    window.location.reload();
  }

  tick();
  if (remaining().done === false) {
    timer = window.setInterval(tick, reduce ? 5000 : 1000);
  }

  // save battery, and keep the reading honest when the tab comes back
  document.addEventListener("visibilitychange", function () {
    if (!document.hidden) tick();
  });
})();
